import React from 'react';
import Text from '@service-victoria/component-library/components/Text';

export const BorderNotice: React.FC<Record<string, never>> = () => (
  <Text.Body fontWeight={600}>
    You do not need a permit as long as you haven&apos;t been in a red or orange zone in the past
    two weeks. Make sure to carry a photo ID and proof of your current address when travelling.{' '}
  </Text.Body>
);

export default BorderNotice;
